import {
  ConfirmationFormSchema,
  FormField,
  FormPayload,
  ValidationStatuses,
  ValidatorTypes,
} from '@cashier/cashier-model';
import { FieldValidator } from '@cashier/cashier-shared';

const getSchemaFields = (formSchema: ConfirmationFormSchema): FormField[] => {
  const { informationFieldMap, fileUploadField, commonFieldMap } = formSchema;

  const fields: FormField[] = [];

  if (informationFieldMap) {
    Object.values(informationFieldMap).forEach((field: FormField) => {
      fields.push(field);
    });
  }

  if (fileUploadField) {
    fields.push(fileUploadField);
  }

  if (commonFieldMap) {
    Object.values(commonFieldMap).forEach((field: FormField) => {
      fields.push(field);
    });
  }

  return fields;
};

export const FormPayloadFactory = {
  fromFormSchema: (formSchema: ConfirmationFormSchema): FormPayload => {
    return getSchemaFields(formSchema).reduce<FormPayload>((acc, field) => {
      const { params, value } = field;

      const validationReport: {
        status: ValidationStatuses;
        errors: string[];
      } = FieldValidator[ValidatorTypes.COMMON](field);

      acc[field.name] = {
        value,
        errors: validationReport.errors,
        validationStatus: validationReport.status,
        interactionCompleted: true,
        ...(params?.isUiOnly ? { isUiOnly: true } : {}),
      };

      return acc;
    }, {});
  },
};
